import React from 'react';
import _map from 'lodash/map';
import { restrictToNumberOnly } from 'common/inputs';
import BMI from 'styles/blocks/bodyMassIndex';
import media from 'styles/media';

const LabelledInput = ({ label, value, onChange, maxLength }) => (
  <BMI.InputContainer>
    <BMI.Label>{label}</BMI.Label>
    <BMI.Input aria-label={label} type="text" inputMode={media.iOS12 ? null : 'numeric'} pattern="\d*" maxLength={maxLength} value={value} onChange={onChange} />
  </BMI.InputContainer>
);

export const Field = ({ questionText, buttonText, onChange, values, onClickConvert }) => (
  <BMI.Div>
    <BMI.Text>{questionText}</BMI.Text>
    <BMI.FlexContainer>
      {_map(values, (value, measure) => (
        <LabelledInput
          key={`bmi-field-${measure}`}
          label={value.label}
          value={value.value}
          onChange={event => onChange({ [measure]: restrictToNumberOnly(event.target.value) })}
          maxLength={value.maxLength}
        />
      ))}
    </BMI.FlexContainer>
    <BMI.MeasureToggleButton onClick={() => onClickConvert()} type="button">{buttonText}</BMI.MeasureToggleButton>
  </BMI.Div>
);
